import "@hotwired/turbo-rails"
require("../stimulus");

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
